import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
    <footer className="app-footer">
        <div className="footer-content">
            <Link to="/privacy" className="footer-link">Политика ПДн</Link>
            <span className="footer-sep" aria-hidden>|</span>
            <Link to="/offer" className="footer-link">Оферта</Link>
        </div>
    </footer>
);

export default Footer;
